import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation, useNavigate, } from 'react-router-dom';
import Header from './components/Header';
import Welcome from './views/welcome';
import OpeningQuestions from './views/OpeningQuestions';
import PatientAgeRange from './views/PatientAgeRange';
import NextSteps from './views/NextSteps';
import SuicideAttempt from './views/SuicideAttempt';
import SuicideAttemptWhen from './views/SuicideAttemptWhen';
import Results from './views/Results';
import PriorTreatment from './views/PriorTreatment';
import ResultScore from './views/ResultScore';
import CrisisResource from './views/CrisisResources';
import Question from './views/Question';
import { questionnaire } from './core/constants';
import { useSelector } from 'react-redux';
import { selectInitialRoute } from './core/navigation_selector';
import './App.scss';
import AntiDepressantPrescription from './views/AntiDepressantPrescription';
import NonDrugTreatment from './views/NonDrugTreatment';

const NavigateControl = () => {
  const initialRoute = useSelector<string>(selectInitialRoute);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname !== initialRoute) {
      navigate(initialRoute as string);
    }
  }, [initialRoute, navigate, pathname]);

  return null;
};

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        {/* <NavigateControl /> */}
        <Routes>
          <Route path="/" element={<Welcome />} />
          <Route path="/opening-questions" element={<OpeningQuestions />} />
          <Route path="/patient-age-range" element={<PatientAgeRange />} />
          <Route path="/onboarding" element={<NextSteps />} />
          <Route path="/suicide-attempt" element={<SuicideAttempt />} />
          <Route path="/suicide-attempt-when" element={<SuicideAttemptWhen />} />
          <Route path="/result" element={<Results />} />
          <Route path="/result-score" element={<ResultScore />} />
          <Route path="/prior-treatment" element={<PriorTreatment />} />
          <Route path="/vague-hurting" element={<CrisisResource />} />
          <Route path="/anti-depressant-prescription" element={<AntiDepressantPrescription />} />
          <Route path="/non-drug-treatment" element={<NonDrugTreatment />} />
          {questionnaire.map((value: any) => {
            return (<Route key={value.route} path={value.route} element={<Question
              name={value.route.replaceAll('-', '_').replace('/', '')}
              label={value.label}
              text={value.text}
              options={value.options}
              route={value.next_route}
            />} />);
          })}
        </Routes>
      </div>
    </Router>
  );
}

export default App;